import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/responses/{listFieldTemplateKey}/restore']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];

const restoreDeletedQuestionnaireResponses = async ({
  questionnaireId,
  listFieldTemplateKey,
  subFieldTemplateIds,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/responses/{listFieldTemplateKey}/restore', {
    listFieldTemplateKey,
    questionnaireId,
  });
  const data = await formsBackendClient.put(path, { subFieldTemplateIds });
  return data.data;
};

export default restoreDeletedQuestionnaireResponses;
